import React from 'react'
import styles from './Documents.module.scss'
import { motion } from "framer-motion"


const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .4}
    } 
}


const Documents = () => {

    return (
        <motion.section 
            className={styles.main}
            id='kak-nachat' 
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.05, once: true}}
            >
        <div className={styles.container}>
        <motion.h2 className={styles.title} variants={titleAnimation}>Необходимые документы</motion.h2>
        <motion.h3 className={styles.subtitle}  variants={titleAnimation}>Основные документы, которые понадобятся для оформления разрешения на работу в России</motion.h3>
        <motion.ul className={styles.list}>
            <motion.li 
                className={styles.cell}
                variants={cardAnimation}
                initial='hidden'
                whileInView='visible'
                viewport={{amount: 0.05, once: true}}
                >   
                    <div className={styles.box_number}>
                        <p className={styles.number}>01</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>ИНН/ОГРН компании</h3>
                    </div>
                </motion.li>
                <motion.li 
                className={styles.cell}
                variants={cardAnimation}
                initial='hidden'
                whileInView='visible'
                viewport={{amount: 0.05, once: true}}
                >
                    <div className={styles.box_number}>
                        <p className={styles.number}>02</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Решение о создании</h3>
                    </div>
                </motion.li>
                <motion.li 
                    className={styles.cell}
                    variants={cardAnimation}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{amount: 0.05, once: true}}
                    >
                    <div className={styles.box_number}>
                        <p className={styles.number}>03</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Лист записи</h3>
                    </div>
                </motion.li>
                <motion.li 
                    className={styles.cell}
                    variants={cardAnimation}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{amount: 0.05, once: true}}
                    >
                    <div className={styles.box_number}>
                        <p className={styles.number}>04</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Приказ о назначении</h3>
                    </div>
                </motion.li>
                <motion.li 
                    className={styles.cell}
                    variants={cardAnimation}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{amount: 0.05, once: true}}
                    >
                    <div className={styles.box_number}>
                        <p className={styles.number}>05</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Выписка из ЕГРЮЛ</h3>
                    </div>
                </motion.li>
                <motion.li 
                    className={styles.cell}
                    variants={cardAnimation}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{amount: 0.05, once: true}}
                    >
                    <div className={styles.box_number}>
                        <p className={styles.number}>06</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Устав</h3>
                    </div>
                </motion.li>
                <motion.li 
                    className={styles.cell}
                    variants={cardAnimation}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{amount: 0.05, once: true}}
                    >
                    <div className={styles.box_number}>
                        <p className={styles.number}>07</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Копия паспорта ВКС</h3>
                    </div>
                </motion.li>
                <motion.li 
                    className={styles.cell}
                    variants={cardAnimation}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{amount: 0.05, once: true}}
                    >
                    <div className={styles.box_number}>
                        <p className={styles.number}>08</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Цветное матовое фото 3х4</h3>
                    </div>
                </motion.li>
                <motion.li 
                    className={styles.cell}
                    variants={cardAnimation}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{amount: 0.05, once: true}}
                    >
                    <div className={styles.box_number}>
                        <p className={styles.number}>09</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Оплату Государственной пошлины</h3>
                    </div>
                </motion.li>
                <motion.li 
                    className={styles.cell}
                    variants={cardAnimation}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{amount: 0.05, once: true}}
                    >
                    <div className={styles.box_number}>
                        <p className={styles.number}>10</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Трудовой договор</h3>
                    </div>
                </motion.li>
                <motion.li 
                    className={styles.cell}
                    variants={cardAnimation}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{amount: 0.05, once: true}}
                    >
                    <div className={styles.box_number}>
                        <p className={styles.number}>11</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Полис ДМС</h3>
                    </div>
                </motion.li>
                <motion.li 
                    className={styles.cell}
                    variants={cardAnimation}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{amount: 0.05, once: true}}
                    >
                    <div className={styles.box_number}>
                        <p className={styles.number}>12</p>
                    </div>
                    <div className={styles.cell_info}>
                        <h3 className={styles.cell_subtitle}>Анкета</h3>
                    </div>
                </motion.li>
        </motion.ul>
        </div>
    </motion.section>
    )
}

export default Documents